// @file Vuex Store module for filtering posts in a wall.
import {
  checkIfPageIsAccessedByReload,
  clearQueryParamsWithoutReloading,
  getSearchParam,
  setQueryParamWithoutReloading,
} from 'bits/location'
import { SurfaceFilter } from 'enums'
import type { Module } from 'vuex'
import type { PostFilterState, RootState } from 'vuexstore/surface/types'

const postFilter: Module<PostFilterState, RootState> = {
  namespaced: true,
  state: {
    filter: SurfaceFilter.All,
    xFilterPopover: false,
  },
  getters: {
    filter: (state: PostFilterState): SurfaceFilter => state.filter,
    isCustomFilter: (state: PostFilterState): boolean => state.filter !== SurfaceFilter.All,
    xFilterPopover: (state: PostFilterState): boolean => state.xFilterPopover,
  },
  mutations: {
    SET_FILTER(state: PostFilterState, filter: SurfaceFilter): void {
      state.filter = filter
    },
    SHOW_FILTER_POPOVER(state: PostFilterState): void {
      state.xFilterPopover = true
    },
    HIDE_FILTER_POPOVER(state: PostFilterState): void {
      state.xFilterPopover = false
    },
  },
  actions: {
    initFilter({ commit }): void {
      if (checkIfPageIsAccessedByReload()) {
        commit('SET_FILTER', SurfaceFilter.All)
        clearQueryParamsWithoutReloading()
        return
      }
      const filterSearchParam = getSearchParam('filter') ?? ''
      switch (filterSearchParam.toLowerCase()) {
        case 'published':
          commit('SET_FILTER', SurfaceFilter.Published)
          break
        case 'submitted':
          commit('SET_FILTER', SurfaceFilter.Submitted)
          break
        default:
          commit('SET_FILTER', SurfaceFilter.All)
          clearQueryParamsWithoutReloading()
          break
      }
    },
    setFilter({ commit }, filter: SurfaceFilter): void {
      commit('SET_FILTER', filter)
      if (filter === SurfaceFilter.All) {
        clearQueryParamsWithoutReloading()
      } else {
        setQueryParamWithoutReloading(`filter=${filter.toLowerCase()}`)
      }
    },
    showFilterPopover({ commit }): void {
      commit('SHOW_FILTER_POPOVER')
    },
    hideFilterPopover({ commit }): void {
      commit('HIDE_FILTER_POPOVER')
    },
  },
}

export default postFilter
